import PinkForm from "Content/InfoPages/PageContent/PinkForm";

function Magazine() {
    return <PinkForm forMagazine/>
}

export default Magazine;